import { render, staticRenderFns } from "./finUnidad.vue?vue&type=template&id=ce654f2e&"
import script from "./finUnidad.vue?vue&type=script&lang=js&"
export * from "./finUnidad.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports